import Vue from 'vue';
import VueMeta from 'vue-meta';

import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import './axios';
import './components';
import './gtm';

import plugins from './plugins/global';
Vue.use(plugins);

Vue.config.productionTip = false;
Vue.use(VueMeta);

import 'core-js';

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
